export var RecentlyUsedHormones = /*#__PURE__*/function (RecentlyUsedHormones) {
  /**
   * YES_STILL is actually never saved to DB.
   * Users who answer it - go to App demoMode.
   */
  RecentlyUsedHormones[RecentlyUsedHormones["YES_STILL"] = 1] = "YES_STILL";
  RecentlyUsedHormones[RecentlyUsedHormones["YES_LAST12M"] = 2] = "YES_LAST12M";
  RecentlyUsedHormones[RecentlyUsedHormones["YES_NOT_IN_LAST12M"] = 3] = "YES_NOT_IN_LAST12M";
  RecentlyUsedHormones[RecentlyUsedHormones["NEVER"] = 4] = "NEVER";
  return RecentlyUsedHormones;
}(RecentlyUsedHormones || {});
export var HormoneType = /*#__PURE__*/function (HormoneType) {
  HormoneType[HormoneType["PILL"] = 1] = "PILL";
  HormoneType[HormoneType["MINI_PILL"] = 2] = "MINI_PILL";
  HormoneType[HormoneType["HORMONAL_IUD"] = 3] = "HORMONAL_IUD";
  HormoneType[HormoneType["IMPLANT"] = 4] = "IMPLANT";
  HormoneType[HormoneType["VAGINAL_RING"] = 5] = "VAGINAL_RING";
  HormoneType[HormoneType["SHOT"] = 6] = "SHOT";
  HormoneType[HormoneType["PATCH"] = 7] = "PATCH";
  HormoneType[HormoneType["OTHER"] = 8] = "OTHER";
  return HormoneType;
}(HormoneType || {});
export const hormoneTypesWithWithdrawal = [HormoneType.PILL, HormoneType.IMPLANT, HormoneType.VAGINAL_RING, HormoneType.PATCH, HormoneType.OTHER];
export var SleepingPattern = /*#__PURE__*/function (SleepingPattern) {
  SleepingPattern[SleepingPattern["REGULAR"] = 1] = "REGULAR";
  SleepingPattern[SleepingPattern["IRREGULAR"] = 2] = "IRREGULAR";
  SleepingPattern[SleepingPattern["SHIFTS"] = 3] = "SHIFTS";
  return SleepingPattern;
}(SleepingPattern || {});